import css from 'styled-jsx/css';

export default css`
  .wrapper-timer {
  }
  .wrapper-timer-mobile {
  }
  .time {
    background: white;
    backdrop-filter: blur(5px);
    border: solid thin #ebebeb;
    width: 60px;
    height: 60px;
    font-size: 22px;
    border-radius: 4px;
    font-weight: 500;
    color: black;
  }
  .wrapper-timer-mobile .time {
    background: white;
    backdrop-filter: blur(5px);
    border: solid thin #ebebeb;
    width: 50px;
    height: 50px;
    font-size: 18px;
    border-radius: 4px;
    font-weight: 500;
  }
  .time span {
    font-size: 10px;
    font-weight: 400;
    text-transform: uppercase;
    color: black;
  }
  .wrapper-timer-mobile .time span {
    font-size: 9px;
    font-weight: 400;
    letter-spacing: 0.4px;
    text-transform: initial;
    color: black;
  }
`;
